module.exports = __webpack_public_path__ + "img/sentioanalysis.1efb5ae6.png";